var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-container"},[(_vm.name === 'crescent')?_c('div',{staticClass:"lds-ring",class:[_vm.size, _vm.color]},[_c('div'),_c('div'),_c('div'),_c('div')]):(_vm.name === 'dots')?_c('div',{staticClass:"lds-dots",class:[_vm.size, _vm.color]},[_c('div'),_c('div'),_c('div')]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }